<template>
  <div class="ma-6">
    <div class=" mt-6">
      <div class=" text-uppercase text-left title-table px-3">
        nghiệp vụ nhập hàng
      </div>
    </div>
    <div class="border">
      <v-progress-linear v-if="loading" indeterminate color="primary"></v-progress-linear>
      <v-simple-table v-else border>
        <template v-slot:default>
          <tbody class="body-table">
            <tr v-if="!histories.length">
              <td colspan="1" class="text-center">
                Không có dữ liệu
              </td>
            </tr>
            <tr v-for="(item, index) in histories.slice(0, 3)" :key="index">
              <td style="font-size: 16px;" class="font-weight-medium text-left">
                {{ formatRelativeDate(item.createdAt) }}
              </td>
              <td style="font-size: 16px;">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <div v-on="on" v-bind="attrs" class="text-ellipsis" v-html="genDescription(item)" />
                  </template>
                  <div v-html="genDescriptionInText(item)" />
                </v-tooltip>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </div>
  </div>
</template>
<script>
import moment from 'moment'
import { get } from 'lodash'
import { mapActions, mapState } from 'vuex'
export default {
  data() {
    return {
      loading: false
    }
  },
  async created() {
    this.loading = true
    await this.fetchCurrentHistories({
      _sort: 'createdAt:DESC',
      dataType: 'import-orders'
    })
    this.loading = false
  },
  computed: {
    ...mapState({
      histories(state) {
        return state['auditTrails'].items
      }
    })
  },
  methods: {
    ...mapActions({
      fetchCurrentHistories: 'auditTrails/fetchItems'
    }),
    formatRelativeDate(dateString) {
      return moment(dateString).format('HH:mm')
    },
    getExtraInfo(trail) {
      const productIndustry = get(trail, 'responseContent.productIndustry.name', '')
      const producer = get(trail, 'responseContent.producer.name', '')
      const productType = get(trail, 'item.responseContent.productType.name', '')
      const code = get(trail, 'responseContent.code', '')
      const result = []
      if (productIndustry.length) result.push(productIndustry)
      if (producer.length) result.push(producer)
      if (productType.length) result.push(productType)
      if (code.length) result.push(`mã <span class="text-blue">${code}</span>`)
      if (result.length) return result.join(' / ')
      return ''
    },
    getAction(trail = {}) {
      if (trail.dataType === 'import-orders') {
        if (trail.action === 'create') {
          return `đã tạo`
        }
        if (trail.action === 'update') {
          if (trail.subAction === 'save-model') {
            return `đã chỉnh sửa nội dung`
          } else if (trail.subAction === 'change-status-created') {
            return `đã chia lại kho cho`
          } else if (trail.subAction === 'remove-model') {
            return `đã chỉnh sửa nội dung`
          } else if (trail.subAction === 'change-status-created') {
            return `đã chuyển trạng thái {{obj}} về đang tạo`
          } else if (trail.subAction === 'change-status-not-approved') {
            return `đã chuyển trạng thái {{obj}} sang chờ duyệt`
          } else if (trail.subAction === 'change-status-approved') {
            return `đã chuyển trạng thái {{obj}} sang duyệt`
          } else if (trail.subAction === 'change-status-send-supplier') {
            return `đã chuyển trạng thái {{obj}} sang gửi hãng`
          } else if (trail.subAction === 'save-model:to-inventory') {
            return `đã chia lại kho`
          }
        }
        if (trail.action === 'delete') {
          return `đã xóa`
        }
      } else return `${trail.dataContent}`
    },
    getRole(role = '') {
      switch (role) {
        case 'manager':
          return 'Admin'
        case 'salemanager':
          return 'Trưởng phòng kinh doanh'
        case 'saleemployee':
          return 'Nhân viên Kinh doanh'
        case 'importemployee':
          return 'Nhân viên Nhập hàng'
        case 'inventorymanager':
          return 'Trưởng kho'
        case 'supplieraccountant':
          return 'Kế toán Hãng'
        case 'director':
          return 'Ban Giám đốc'
        case 'saledeputy':
          return 'Phó phòng kinh doanh'
        default:
          return ''
      }
    },
    getRoleAndUsername(trail = {}) {
      return `<span class="text-blue">${this.getRole(get(trail, 'user.role', ''))} ${get(
        trail,
        'user.name',
        ''
      )}</span>`
    },
    genDescription(trail = {}) {
      const roleUser = this.getRoleAndUsername(trail)
      let action = this.getAction(trail)
      let obj = this.getExtraInfo(trail)
      if (action.indexOf('{{obj}}') > -1) action = action.replace('{{obj}}', obj)
      else action += ' ' + obj
      return roleUser + ' ' + action
    },
    genDescriptionInText(trail) {
      const descriptionHtml = this.genDescription(trail)
      const div = document.createElement('div')
      div.innerHTML = descriptionHtml
      return div.innerText
    }
  },
  watch: {}
}
</script>
<style>
.text-blue {
  color: #0d47a1;
}
</style>
<style scoped lang="scss">
.title-table {
  background-color: #0d47a1;
  width: 184px;
  font-size: 14px;
  height: 35px;
  padding-top: 8px;
  color: white;
  white-space: nowrap;
}

.border {
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 5px;
}

.body-table {
  min-width: 970px;
  overflow: hidden;
}

.text-ellipsis {
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  line-clamp: 1;
  -webkit-box-orient: vertical;
}

.text-blue {
  color: #0d47a1;
}
</style>
